import v20110510 from './20110510';
import v20110729 from './20110729';
import v20110925 from './20110925';
import v20111031 from './20111031';
import v20120917 from './20120917';
import v20140708 from './20140708';
import v20140805 from './20140805';
import v20150216 from './20150216';
import v20150430 from './20150430';
import v20150515 from './20150515';
import v20151117 from './20151117';
import v20170119 from './20170119';
import v20220701 from './20220701';
import v20250225 from './20250225';
import v20251016 from './20251016';


export default {
	20110510: v20110510,
	20110729: v20110729,
	20110925: v20110925,
	20111031: v20111031,
	20120917: v20120917,
	20140708: v20140708,
	20140805: v20140805,
	20150216: v20150216,
	20150430: v20150430,
	20150515: v20150515,
	20151117: v20151117,
	20170119: v20170119,
	20220701: v20220701,
	20250225: v20250225,
	20251016: v20251016
};
